import React, { Component } from 'react';

class PrevIcon extends Component {
  render() {
    return (<><i className='fa fa-angle-left'></i><i className='fa fa-angle-left'></i>&nbsp;&nbsp; </>);
  }
}

export default PrevIcon;